import React, { useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import { Trash2 } from 'lucide-react';
import './Notes.css';

import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  TableContainer,
  Tbody,
  Table, Thead,
  Tr, Td
} from '@chakra-ui/react';
export default function FileDrawer(props) {
  const { closeDrawer } = props;
  const handleOnClose = () => {
    closeDrawer();
  }
  return (
    <Drawer
      isOpen={props.isFileDrawerOpen}
      placement='right'
      size='sm'
      onClose={handleOnClose} >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Add </DrawerHeader>
        <DrawerBody>
          <TableContainer className='card card-detail mt-1'>
            <Table id="table-to-xls" variant='simple' size='sm' >
              <Thead>
                <Tr>
                  <Td className='py-1 th-color'>Action</Td>
                  <Td className='py-1 th-color'>Name</Td>
                  <Td className='py-1 th-color'>Time</Td>
                  <Td className='py-1 th-color'>Added By</Td>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td><Trash2 color="#ff176b" size="16px" strokeWidth="1" /></Td>
                  <Td className='font-colors'>Sukanya</Td>
                  <Td className='font-colors'>10:30</Td>
                  <Td className='font-colors'>demo</Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </DrawerBody>
        <center><DrawerFooter style={{ display: 'inline-block' }} >
          <div className='gap-3 d-flex'>
            <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
              Cancel
            </button>
            <button className='create-button' >Submit</button>
          </div>
        </DrawerFooter></center>
      </DrawerContent>
    </Drawer>
  )
}